import { useNavigate } from "react-router";

import { useCurrentCompanyId } from "@/hooks";
import {
  defaultSearchCandidateDistanceOption,
  defaultSearchYearsOfExperienceOption,
} from "@/lib/constants";
import { storage } from "@/lib/storage";
import { Job } from "@/types";

export const useHandleDefaultSearchForJob = () => {
  const currentCompanyId = useCurrentCompanyId();
  const navigate = useNavigate();

  return ({ job }: { job: Job }) => {
    // Ensure that the search parameters are set to their defaults before
    // we navigate to the search page. This is because we use the defaults
    // to get the recommended candidates.
    storage.setSearchParameters({
      jobId: job.id,
      query: job.title,
      location: `${job.city}, ${job.state}`,
      radius: defaultSearchCandidateDistanceOption.value,
      yoe: defaultSearchYearsOfExperienceOption.value,
      customFilter: undefined,
    });

    void navigate(`/companies/${currentCompanyId}/search`);
  };
};
